var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"button-reset"},[_c('svg-icon',{staticClass:"button-reset__icon",attrs:{"name":"icon-close"}}),_vm._v(" "),_vm._t("default",function(){return [_vm._v("\n        "+_vm._s(_vm.$t('reset'))+"\n    ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }